<template>
  <v-dialog v-model="displayConfigDialog" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">Configure</v-card-title>
      <v-card-text class="py-0 my-0">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="configValues.displayName"
              label="Display Name"
              persistent-hint
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <AccountSelection
              @onAccountSelected="onAccountSelected"
              :accountSelection="configValues.account"
              label="Account"
            />
          </v-col>
          <v-col class="py-0">
            <date-range-picker
              :dateRange="configValues.dateRange"
              @onDates="onDateRange"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-btn class="ma-2" @click="onConfigureClose()">Close</v-btn>
        <v-btn class="primary ma-2" @click="onSave()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AccountSelection from "../common/AccountSelector.vue";
import DateRangePicker from '../common/DateRangePicker.vue';
import AccountDatesConfig from './AccountDatesConfig.js';

export default {
  name: "DashboardConfiguration",
  components: {
    AccountSelection,
    DateRangePicker
  },
  props: {
    showConfigDialog: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  async created() {
    await this.$store.dispatch("getTransactions");
    await this.$store.dispatch("getAccounts");
    this.init();
  },
  data: () => ({
    configValues: new AccountDatesConfig({}),
    noAccount: false,
  }),
  computed: {
    displayConfigDialog() {
      return this.showConfigDialog || this.noAccount;
    },
  },
  methods: {
    init() {
      if (this.config) {
        this.configValues = new AccountDatesConfig(this.config);
      }
      if (!this.configValues.account) {
        this.noAccount = true;
      }
    },
    onAccountSelected(account) {
      this.configValues.account = account;
      this.configValues.displayName = this.configValues.displayName || account.name;
    },
    onDateRange(dateRange) {
      this.configValues.dateRange = dateRange.map(d => new Date(d));
    },
    onConfigureClose() {
      this.init();
      this.noAccount = false;
      this.$emit("onConfigureClose");
    },
    onSave() {
      this.$emit("onNewConfig", this.configValues.toJson());      
      this.noAccount = false;
      this.$emit("onConfigureClose");
    }
  },
};
</script>